/*
  Store Builder craft: what sticks (15 Oct 2026; store-kit/README.md, "Craft hooks"). Deferred after
  store-builder-craft.js, which mirrors the hooks to data-sb-* on <html>; kept apart so that script stays under the
  10 KB patch limit. No network, no markup from strings.
  - The header (--sb-header-scroll, round 4): hide or stay sets Horizon's own sticky mode (scroll-up or always)
    before Horizon's header script, a module further down the page, starts; layout keeps the layout's.
  - The phone's sticky buy bar (--sb-sticky-buy): off unless a direction sets on, which house rules §5 forbid until
    the owner says otherwise. Once the buy box scrolls up out of view, a slim bar whose button presses the real
    Add to Cart; a layout with Horizon's own bar keeps that.
*/
(() => {
const doc = document;
const root = doc.documentElement;

const mode = { hide: 'scroll-up', stay: 'always' }[root.getAttribute('data-sb-header-scroll')];
if (mode) doc.querySelector('#header-component[sticky]')?.setAttribute('sticky', mode);

function sticky() {
  if (root.getAttribute('data-sb-sticky-buy') !== 'on' || !('IntersectionObserver' in window)) return;
  if (doc.querySelector('sticky-add-to-cart, .sb-sticky-buy')) return;
  const find = () => doc.querySelector('main[data-template^="product"] product-form-component [name="add"]');
  const real = find();
  if (!real) return;
  const details = real.closest('.product-details, .shopify-section') || real;
  const make = (tag, className) => Object.assign(doc.createElement(tag), { className });
  const [bar, price, button] = [make('div', 'sb-sticky-buy'), make('span', 'sb-sticky-buy__price'), make('button', 'button sb-sticky-buy__button')];
  button.type = 'button';
  bar.setAttribute('role', 'region');
  bar.setAttribute('inert', '');
  bar.append(price, button);
  doc.body.append(bar);
  const sync = () => {
    const now = find();
    if (!now) return;
    const amount = details.querySelector('product-price .price bdi') || details.querySelector('product-price .price');
    price.textContent = amount ? amount.textContent.trim() : '';
    button.textContent = now.textContent.trim();
    bar.setAttribute('aria-label', button.textContent);
    button.disabled = now.disabled;
  };
  button.addEventListener('click', () => {
    const now = find();
    if (now && !now.disabled) now.click();
  });
  const footer = doc.querySelector('footer');
  const state = { past: false, footer: false };
  const io = new IntersectionObserver((entries) => {
    for (const { target, isIntersecting, boundingClientRect } of entries) {
      if (target === footer) state.footer = isIntersecting;
      else state.past = !isIntersecting && boundingClientRect.bottom < 0;
    }
    const shown = state.past && !state.footer;
    if (shown) sync();
    bar.toggleAttribute('data-shown', shown);
    bar.toggleAttribute('inert', !shown);
  });
  io.observe(real.closest('product-form-component') || real);
  if (footer) io.observe(footer);
  let frame = 0;
  new MutationObserver(() => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(sync);
  }).observe(details, { subtree: true, childList: true, characterData: true, attributeFilter: ['disabled'] });
  sync();
}

sticky();
})();
